import { ElCheckbox } from 'element-plus';

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(ElCheckbox);
});
